import { render, staticRenderFns } from "./limitCardGroup.vue?vue&type=template&id=37f5602b&scoped=true&"
import script from "./limitCardGroup.vue?vue&type=script&lang=js&"
export * from "./limitCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5602b",
  null
  
)

export default component.exports